import Services from './base-services'

const service = new Services('bookAssessmentItem')
import mapParameters from '../utils/map-parameters'

export default {
    getItemsByBookAndUser(data: any) {
        const params = mapParameters({
            userId: data && data.userId ? data.userId : null,
            bookId: data && data.bookId ? data.bookId : null,
        })
        return service.post(`getItemsByBookAndUser`, params)
    },
    evaluateAssessmentAnswerTrueOrFalse(data: any) {
        return service.post(
            `evaluateAssessmentAnswerTrueOrFalse?catalogId=${data.catalogId}&questionId=${data.questionId}&trueOrFalse=${data.trueOrFalse}&usedWildcard=${data.usedWildcard}&streak=${data.streak}&lastQuestionOfGroup=${data.lastQuestionOfGroup}&lastQuestionOfBook=${data.lastQuestionOfBook}`,
            data
        )
    },
    evaluateAssessmentAnswer4Options(data: any) {
        return service.post(
            `evaluateAssessmentAnswer4Options?catalogId=${data.catalogId}&questionId=${data.questionId}&answerId=${data.answerId}&usedWildcard=${data.usedWildcard}&streak=${data.streak}&lastQuestionOfGroup=${data.lastQuestionOfGroup}&lastQuestionOfBook=${data.lastQuestionOfBook}`,
            data
        )
    },
    findCloneQuestion(questionArray: any[]) {
        return questionArray.find((question) => question.itemVariant === 'B')
    },
}
